import { render, staticRenderFns } from "./Signup.Detail.vue?vue&type=template&id=589b4206&"
import script from "./Signup.Detail.vue?vue&type=script&lang=js&"
export * from "./Signup.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports